import _defineProperty from "/home/runner/work/freeCodeCamp/freeCodeCamp/node_modules/.pnpm/@babel+runtime@7.27.3/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
// src/getDotPath/getDotPath.ts
function getDotPath(issue) {
  var _issue$path;
  if ((_issue$path = issue.path) !== null && _issue$path !== void 0 && _issue$path.length) {
    let dotPath = "";
    for (const item of issue.path) {
      const key = typeof item === "object" ? item.key : item;
      if (typeof key === "string" || typeof key === "number") {
        if (dotPath) {
          dotPath += ".".concat(key);
        } else {
          dotPath += key;
        }
      } else {
        return null;
      }
    }
    return dotPath;
  }
  return null;
}

// src/SchemaError/SchemaError.ts
var SchemaError = class SchemaError extends Error {
  /**
   * Creates a schema error with useful information.
   *
   * @param issues The schema issues.
   */
  constructor(issues) {
    super(issues[0].message);
    /**
     * The schema issues.
     */
    _defineProperty(this, "issues", void 0);
    this.name = "SchemaError";
    this.issues = issues;
  }
};
export { SchemaError, getDotPath };